// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"580":"075e93f1","918":"f9e16448"}[chunkId] + ".chunk.js";
};